import { React, useState } from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid'

const testItems = [
    {
        ElapsedTime: '10:12:02',
        Created: '03:08 am, 16 Nov 2022',
        Confirmed: '03:12 am, 16 Nov 2022',
        Location: '4321 Simerly Creek Road, Unicoi, TN, 37692, US',
        Destination: '3421 Unicoi Dr, Unicoi, TN 37692, USA, 3421 Unicoi Dr, Unicoi, TN, 37692',
        CaseNumber: '0006455405',
        Operator: "Harry's Towing & Auto Repair",
        Status: 'In Progress - Operator Assigned',
        Distance: '8.16 mi',
        OriginalETA: '4:17:00 am',
        CurrentETA: '',
    },
    {
        ElapsedTime: '10:12:02',
        Created: '03:08 am, 16 Nov 2022',
        Confirmed: '03:12 am, 16 Nov 2022',
        Location: '4321 Simerly Creek Road, Unicoi, TN, 37692, US',
        Destination: '3421 Unicoi Dr, Unicoi, TN 37692, USA, 3421 Unicoi Dr, Unicoi, TN, 37692',
        CaseNumber: '0006455405',
        Operator: "Harry's Towing & Auto Repair",
        Status: 'In Progress - Operator Assigned',
        Distance: '8.16 mi',
        OriginalETA: '4:17:00 am',
        CurrentETA: '',
    },
    {
        ElapsedTime: '10:12:02',
        Created: '03:08 am, 16 Nov 2022',
        Confirmed: '03:12 am, 16 Nov 2022',
        Location: '4321 Simerly Creek Road, Unicoi, TN, 37692, US',
        Destination: '3421 Unicoi Dr, Unicoi, TN 37692, USA, 3421 Unicoi Dr, Unicoi, TN, 37692',
        CaseNumber: '0006455405',
        Operator: "Harry's Towing & Auto Repair",
        Status: 'In Progress - Operator Assigned',
        Distance: '8.16 mi',
        OriginalETA: '4:17:00 am',
        CurrentETA: '',
    },
    {
        ElapsedTime: '10:12:02',
        Created: '03:08 am, 16 Nov 2022',
        Confirmed: '03:12 am, 16 Nov 2022',
        Location: '4321 Simerly Creek Road, Unicoi, TN, 37692, US',
        Destination: '3421 Unicoi Dr, Unicoi, TN 37692, USA, 3421 Unicoi Dr, Unicoi, TN, 37692',
        CaseNumber: '0006455405',
        Operator: "Harry's Towing & Auto Repair",
        Status: 'In Progress - Operator Assigned',
        Distance: '8.16 mi',
        OriginalETA: '4:17:00 am',
        CurrentETA: '',
    },
]

export default function ListItems(props) {

    const [items, setItems] = useState(testItems || []);


    return (
        <>
            <div className="overflow-hidden sm:rounded-md">
                    {items.map((item, index) => (
                        <div key={index} className="mt-2">
                            <a href="#1" className="block">
                                <div className="flex justify-between rounded-md bg-green-300 hover:bg-blue-300">
                                    <div className='m-4 flex flex-col'>
                                        <p className="font-bold text-sm">{item.Operator}, Tow, Chevrolet Corvette 2015</p>
                                        <p className="text-sm mt-4"><b>Elapsed Time:</b> 09:58:10</p>
                                    </div>

                                    <div className="flex">
                                        <ChevronRightIcon className="w-8 h-8 text-black my-auto" />
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}


            </div>
        </>
    )
}
